import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import Likes from '~/components/reactions/HorizontalLike.vue';
import DdButton from '~/components/DdButton.vue';
import WebpPicture from '~/components/WebpPicture.vue';
import ShareButton from '~/components/share/ShareButton.vue';
import { useFeedStore } from '~/storeModules/useFeed.js';
export default {
  props: ['post', 'feedName', 'isPreview'],
  components: {
    Likes: Likes,
    DdButton: DdButton,
    WebpPicture: WebpPicture,
    ShareButton: ShareButton,
    PanelButton: function PanelButton() {
      return import('~/components/panels/PanelButton.vue');
    }
  },
  data: function data() {
    return {
      watching: false,
      isVisible: false,
      time: new Date().getTime()
    };
  },
  computed: {
    isOwner: function isOwner() {
      var _this = this;
      var isOwner = false;
      if (!this.$auth.user) return isOwner;
      if (this.post.authorModel == 'user' && this.post.authorId == this.$auth.user.id) {
        isOwner = true;
      }
      if (this.post.authorModel == 'company' && this.$auth.user.moders) {
        isOwner = this.$auth.user.moders.some(function (o) {
          return o.company.id == _this.post.authorId && o.approved;
        });
      }
      return isOwner;
    },
    url: function url() {
      return "".concat(process.env.baseUrl).concat(this.localePath(this.post.link));
    },
    feedStoreName: function feedStoreName() {
      return "feed/".concat(this.feedName);
    },
    feedsStore: function feedsStore() {
      return useFeedsStore();
    },
    feedStore: function feedStore() {
      return useFeedStore(this.feedStoreName);
    },
    pubDate: function pubDate() {
      return new Date(this.post.pubDate);
    },
    type: function type() {
      if (this.post.modelName == 'publication') return this.post.type;
      return this.post.modelName;
    },
    now: function now() {
      return useTimeStore().now;
    },
    ago: function ago() {
      return this.$timeformat.ago(this.pubDate, this.now);
    },
    modelLink: function modelLink() {
      var link;
      switch (this.post.modelName) {
        case 'post':
          link = '/cases';
          break;
        case 'column':
          link = '/article';
          break;
        case 'news':
          link = '/';
          break;
        case 'event':
          link = '/events';
          break;
        default:
          link = '/';
          break;
      }
      return link;
    },
    postId: function postId() {
      return "".concat(this.feedName, "-").concat(this.post.id, "-").concat(this.time);
    },
    image: function image() {
      return this.post.images[0];
    },
    imgSrc: function imgSrc() {
      return this.image.replace('/standart/', '/medium/');
    },
    srcSet: function srcSet() {
      return "".concat(this.imgSrc, " 720w, ").concat(this.image);
    },
    webpSet: function webpSet() {
      return "".concat(this.imgSrc, ".webp 720w, ").concat(this.image, ".webp");
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    setTimeout(function () {
      _this2.observe();
    }, 1000);
  },
  methods: {
    expand: function expand() {
      this.feedStore.toggleFullText(this.post.id);
      this.$emit('expand', this.post.id);
    },
    update: function update(_update) {
      this.feedsStore.updatePosts({
        ids: [this.post.id],
        update: _update
      });
    },
    watch: function watch() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this3.post.watched && !_this3.watching)) {
                _context.next = 7;
                break;
              }
              _this3.watching = true;
              _context.next = 4;
              return _this3.$axios.$get('/views/watch', {
                params: {
                  modelName: _this3.post.modelName,
                  modelId: _this3.post.modelId,
                  source: 'feed'
                },
                progress: false
              }).catch(function (err) {
                return console.log(err);
              });
            case 4:
              data = _context.sent;
              _this3.feedsStore.updatePosts({
                ids: [_this3.post.id],
                update: {
                  watched: true
                }
              });
              _this3.watching = false;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    observe: function observe() {
      var _this4 = this;
      var scrollTopThreshold = 0.3;
      this.feedObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          _this4.isVisible = entry.isIntersecting && entry.intersectionRatio >= scrollTopThreshold;

          // Count if was on scree for atleast for 1 second
          if (_this4.isVisible) {
            setTimeout(function () {
              if (_this4.isVisible) _this4.watch();
            }, 1000);
          }
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: scrollTopThreshold
      });
      var feed = this.$el;
      if (feed) this.feedObserver.observe(feed);
    },
    unobserve: function unobserve() {
      if (this.feedObserver) this.feedObserver.disconnect();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unobserve();
  }
};